import { createSlice } from "@reduxjs/toolkit";

export const transactionsReducer = createSlice({
  name: "transactions",
  initialState: {
    details: [
        { crypto: {
            code: "Exxfafawsdytsewogsdsgsdhsdrfhdfsg"
            },
            QRcode: "https://upload.wikimedia.org/wikipedia/commons/d/d0/QR_code_for_mobile_English_Wikipedia.svg"
        }, 
        { bank: {
        } 
    }],
    transactions: [],
    isTransactions: false,
  },
  reducers: {
    addTransaction: (state, action) => {
      state.transactions.push(action.payload);
    },

    removeTransaction: (state, action) => {
      state.transactions = state.transactions.filter(
        (transaction) => transaction.key !== action.payload.key
      );
    },

    setTransactions: (state, action) => {
      return { ...state, ...action.payload };
    },
  },
});
